import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { WritableDraft } from 'immer';
import { useConfigApi } from '../../api';
import { ConfigStoreEntity } from '@/types/redux';

export const getThemeData = createAsyncThunk(
  'config/data',
  async (id: string | undefined, { rejectWithValue }) => {
    const { getTheme } = useConfigApi();
    try {
      return await getTheme();
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const initialState: ConfigStoreEntity = {
  data: undefined,
  isLoading: false,
  error: undefined,
};

const configSlice = createSlice({
  name: 'configSlice',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = undefined;
      state.data = { ...state } as WritableDraft<unknown | undefined>;
    },
    clearParentData: (state) => {
      state.data = initialState.data;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getThemeData.pending, (state) => {
        state.isLoading = true;
        state.error = undefined;
      })
      .addCase(getThemeData.fulfilled, (state, action) => {
        state.data = action.payload as WritableDraft<unknown | undefined>;
        state.isLoading = false;
        state.error = undefined;
      })
      .addCase(getThemeData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as ConfigStoreEntity['error'];
      });
  },
});

export const { clearError, clearParentData } = configSlice.actions;
export default configSlice.reducer;
